// extracted by mini-css-extract-plugin
export var modal = "_t2-0";
export var table = "_t2-1";